/** @format */

import {generateGraphPointName} from 'helpers/miscHelpers';

import {GraphComplexValuesList, GraphStat} from '../../models/common';

interface Options {
  graphStatsWithMediaplanStats: GraphStat[];
  allDates: string[];
}

const collectGraphComplexValues = ({
  graphStatsWithMediaplanStats,
  allDates,
}: Options): GraphComplexValuesList => {
  const result: GraphComplexValuesList = {};

  // Важно: Данные на входе должны быть уже сортированы по дате!
  // Не должно быть пропущенных дат в периоде.
  // В противном случае может случиться рассинхрон между датой и pointName

  allDates.forEach((date, index) => {
    const stat = graphStatsWithMediaplanStats.find(value => value.date === date);
    if (stat) {
      const pointName = generateGraphPointName(index);
      result[pointName] = {
        date: stat.date,
        values: {
          spent: stat.budget,
          impressions: stat.shows,
          clicks: stat.clicks,
          revenue: stat.income,
          engagement: stat.engagement,
          reach: stat.reach,
          bounces: stat.bounces,
          sessions: stat.sessions,
          videoComplete: stat.videoComplete,
          conversions: stat.conversions,
        },
      };
    }
  });

  return result;
};

export {collectGraphComplexValues};
